import React from 'react';

export default function FeedbackLinks(props) {
    return (
        <React.Fragment>
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h3 className="panel-title">
                        <a href={props.lingua.reviewLink} target="_blank">
                            {props.lingua.reviewLinkText}
                            <span className="sr-only">{props.lingua.externalLinkSrText}</span>
                        </a>
                    </h3>
                </div>
            </div>
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h3 className="panel-title">
                        <a href={props.lingua.helpLink} target="_blank">
                            {props.lingua.helpLinkText}
                            <span className="sr-only">{props.lingua.externalLinkSrText}</span>
                        </a>
                    </h3>
                </div>
            </div>
            {!props.disableSiteFeedback &&
                <div className="panel panel-default">
                    <div className="panel-heading" onClick={props.opinionLabInstance.createLauncher} role="presentation">
                        <h3 className="panel-title">
                            <a href="#" target="_blank">
                                {props.lingua.supportLinkText}
                                <span className="sr-only">{props.lingua.externalLinkSrText}</span>
                            </a>
                        </h3>
                    </div>
                </div>
            }
        </React.Fragment>
    );
}
